<template>
  <li class="kd-theme-color-switcher">
    <div class="kd-theme-color-switcher__bg-circle">
      <div
          class="kd-theme-color-switcher__active-color"
          :style="{ backgroundColor: activeColor }"
          @click="toggleSwitcher"
          v-click-outside="clickOutsideConfig"
        ></div>
      <div
        v-if="switcherVisible"
        class="kd-theme-color-switcher__chooser"
      >
        <div
          class="kd-theme-color-switcher__option"
          v-for="themeColor in themeColors"
          :key="themeColor.id"
          @click="optionClicked(themeColor)"
          :style="{
            backgroundColor: themeColor.color,
            borderColor: themeColor.color === activeColor ? highlightColor : themeColor.color,
          }"
        ></div>
      </div>
    </div>
    <div class="kd-theme-color-switcher__label">{{ label }}</div>
  </li>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import domHelpers from '@/shared/dom-helpers';

import {
  THEME_COLORS,
  ACTIVE_THEME,
} from '@/store/getter-types';

import {
  ACTIVATE_THEME_BY_ID,
} from '@/store/mutation-types';

export default {
  data() {
    return {
      // colors: ['#FF0000', '#00FF00', '#0000FF'],
      activeColor: '#00A3E0',
      highlightColor: '#01A3DF',
      switcherVisible: false,
      clickOutsideConfig: {
        handler: this.onClickOutside,
        middleware: this.shouldDeactivateLayer,
        events: ['dblclick', 'click', 'touchend'],
      },
    };
  },
  props: {
    label: String,
  },
  computed: {
    ...mapGetters({
      themeColors: THEME_COLORS,
      ACTIVE_THEME,
    }),
  },
  methods: {
    ...mapMutations({
      activateThemeById: ACTIVATE_THEME_BY_ID,
    }),
    onClickOutside() {
      this.switcherVisible = false;
    },
    shouldDeactivateLayer(event) {
      if (event.target.classList.contains('kd-theme-color-switcher__option')) {
        return false;
      }
      return true;
    },
    toggleSwitcher() {
      this.switcherVisible = !this.switcherVisible;
    },
    optionClicked({ id, color }) {
      this.activateThemeById(id);
      this.activeColor = color;
    },
    isAncestorOf: domHelpers.isAncestorOf,
  },
  watch: {
    ACTIVE_THEME(activeTheme) {
      if (activeTheme && activeTheme.colorUi) {
        this.activeColor = activeTheme.colorUi;
      }  
    },
  },
  mounted() {
    if (this.ACTIVE_THEME && this.ACTIVE_THEME.colorUi) {
      this.activeColor = this.ACTIVE_THEME.colorUi;
    }
  },
};
</script>

<style lang="scss">
  .kd-theme-color-switcher {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 22px;
    position: relative;
  }

  .kd-theme-color-switcher__option, .kd-theme-color-switcher__active-color {
    border-radius: 3px;
    width: 20px;
    height: 20px;
    display: inline-block;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    & + & {
      margin-left: 10px;
    }
  }

  // only options, not the active color in the sidebar
  .kd-theme-color-switcher__option {
    border-style: solid;
    border-width: 2px;
  }

  // only for the active color alone
  .kd-theme-color-switcher__active-color {}

  .kd-theme-color-switcher__chooser {
    background-color: white;
    position: absolute;
    top: 0;
    right: 50px;
    width: 40px;
    border-radius: 20px;
    width: auto;
    white-space: nowrap;
    padding: 10px;
    overflow: hidden;
  }

  .kd-theme-color-switcher__bg-circle {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 50%;
    margin-bottom: 14px;
    position: relative;

    @media all and (max-width: 1200px) {
      width: 30px;
      height: 30px;
    }
  }

  .kd-theme-color-switcher__label {
    font-size: 13px;
    font-weight: 600;
  }
</style>
